import "./SafetyStandards.module.css";
import Header from "@/reusable_sections/Header";
import Safety from "./sections/Safety";
import Compliance from "./sections/Compliance";
import SafetyFaq from "./sections/SafetyFaq";
import Footer from "@/reusable_sections/Footer";
export default function SafetyStandardsPage() {
  return <div>
      <Header />
      <Safety />
      <Compliance />
      <SafetyFaq />
      <Footer />
    </div>;
}